import React from "react";
import TextInfo from "@/bit/components/components.text";
import ImageStepsCard from "./card";

const ImageStepsComponent = (props) => {
  return (
    <>
      <div className="image-spets-card container">
        <div className="content-container">
          {props["Text-1"] && props["Text-1"].text && (
            <div className="title-cont">
              <TextInfo {...props["Text-1"]} />
            </div>
          )}

          {props["Card-1"] && <ImageStepsCard {...props["Card-1"]} />}
        </div>
      </div>
      <style jsx>{`
        .image-spets-card {
          & :global(*) {
            line-height: 120%;
          }

          .content-container {
            .title-cont {
              margin: 1rem 0;
            }
          }
        }
      `}</style>
    </>
  );
};

export default ImageStepsComponent;
